import React, { useCallback, useEffect, useState } from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import MaskingConfigDialog from "./MaskingConfigForm";
import ToolBar from "../../components/Layout/ToolBar";
import useTable from '../../components/useTable';
import * as maskingConfigService from '../../services/maskingConfigService';
import ActionsTableCell from '../../components/MaterialTable/ActionsTableCell';
import useAlert from '../../components/useAlert';
import useLinearProgress from '../../components/useLinearProgress';
import AlertDialog from '../../components/AlertDialog';

const maskingConfigColumns = [
    { id: 'id', label: 'ID' },
    { id: 'regExp', label: 'Regular Expression' },
    { id: 'replacement', label: 'Replacement' },
];

const MASKING_CONFIG_DIALOGS = {
    CREATE_EDIT_DIALOG: 'masking_config',
    CONFIRMATION_DIALOG: 'alert'
}

const MaskingConfigs = () => {
    const [maskingConfigs, setMaskingConfigs] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [open, setOpen] = useState(false);
    const [dialogType, setDialogType] = useState("");

    const {
        TblContainer,
        TblHead
    } = useTable(maskingConfigs, maskingConfigColumns);

    const {
        Alert,
        status,
        showSuccess,
        showError
    } = useAlert();

    const {
        LinearPorgress,
        isLoading,
        setIsLoading
    } = useLinearProgress(true);

    const getMaskingConfigs = useCallback(() => {
        maskingConfigService.getMaskingConfigs()
            .then((response) => {
                const result = response.data.items;
                setMaskingConfigs(result || []);
            })
            .catch(error => {
                showError(error.response?.data?.message || "Error fetching Masking Configs");
            }).finally(() => {
                setIsLoading(false);
            });
    }, [showError, setIsLoading]);

    useEffect(() => {
        getMaskingConfigs();
    }, [getMaskingConfigs]);

    const handleDeleteClicked = () => {
        maskingConfigService.removeMaskingConfig(selectedRow.id)
            .then(() => {
                showSuccess();
                getMaskingConfigs();
            }).catch(error => {
                showError(error.response?.data?.message || "Error deleting Masking Config");
            });
    }

    return (
        <React.Fragment>
            {status ? <Alert /> : null}
            <ToolBar
                title="Add Masking Config"
                setOpen={() => {
                    setSelectedRow(null);
                    setDialogType(MASKING_CONFIG_DIALOGS.CREATE_EDIT_DIALOG);
                    setOpen(true);
                }}
            />
            {isLoading ? <LinearPorgress /> :
            <TblContainer>
                <TblHead />
                <TableBody>
                    {maskingConfigs && maskingConfigs.map(key => (
                        <TableRow
                            key={key.id}
                            onClick={() => setSelectedRow(key)}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell >{key.id}</TableCell>
                            <TableCell >{key.regExp}</TableCell>
                            <TableCell >{key.replacement}</TableCell>
                            <ActionsTableCell
                                onEdit={() => {
                                    setDialogType(MASKING_CONFIG_DIALOGS.CREATE_EDIT_DIALOG);
                                    setOpen(true);
                                }}
                                onDelete={(e) => {
                                    setDialogType(MASKING_CONFIG_DIALOGS.CONFIRMATION_DIALOG);
                                    setOpen(true);
                                }}
                            />
                        </TableRow>
                    ))}
                </TableBody>
            </TblContainer>}
            {dialogType === MASKING_CONFIG_DIALOGS.CREATE_EDIT_DIALOG ?
                <MaskingConfigDialog
                    open={open}
                    setOpen={setOpen}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    getMaskingConfigs={getMaskingConfigs}
                />
                : dialogType === MASKING_CONFIG_DIALOGS.CONFIRMATION_DIALOG ?
                    <AlertDialog
                        open={open}
                        setOpen={setOpen}
                        setSelectedRow={setSelectedRow}
                        confirmAction={handleDeleteClicked}
                    />
                    : null
            }
        </React.Fragment>
    );
}

export default MaskingConfigs;
